import ComparisonBarTripleComponent from '@/DesignSystem/features/comparison/ComparisonBarTriple';

const ProbabilidadesPartidoComponent = ({ home, draw, away }) => {
    const toNumber = (val) => parseFloat(val?.toString().replace('%', '') || '0');

    const parsedHome = toNumber(home);
    const parsedDraw = toNumber(draw);
    const parsedAway = toNumber(away);

    return <ComparisonBarTripleComponent left={parsedHome} center={parsedDraw} right={parsedAway} />;
};

export default ProbabilidadesPartidoComponent;
